// extracted by mini-css-extract-plugin
module.exports = {"list":"PanelWrapper_list__1FAmS","itemWrapper":"PanelWrapper_itemWrapper__3UcgU"};